import { useRef } from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FaUndo, FaUpload } from 'react-icons/fa';
import IconButton from '../../util/IconButton';
import { useSlidePromptHandlers } from './useSlidePromptHandlers';

const watermarkUrl = `https://aqppi3wus2-cdn-endpoint.azureedge.net/teams-gw-prompts/teams-gw-default/en-US/powered%20by%20poly_horizontal_small.png`;

function SlidePrompt({
  name,
  slideUrl,
  defaultSlideUrl,
  setPromptError,
  setShowPromptError,
}) {
  const inputRef = useRef();
  const {
    imgRef,
    isDefault,
    revertTitle,
    values,
    currentSlideUrl,
    updatePromptsInfo,
    usePremiumPrompts,
    onImageLoad,
    onImgChange,
    onRevertClick,
  } = useSlidePromptHandlers(
    name,
    setPromptError,
    setShowPromptError,
    slideUrl,
    defaultSlideUrl,
  );

  if (updatePromptsInfo) {
    values[name] = undefined;
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'relative',
          top: '10px',
          right: '20px',
          height: '0',
          padding: 0,
          zIndex: 100,
        }}
      >
        <input
          data-testid={name}
          id={name}
          name={name}
          type="file"
          accept="image/png, image/gif, image/jpeg, image/bmp"
          ref={inputRef}
          onClick={() => {
            // clear the current value to allow the user to select the same file again
            inputRef.current.value = '';
          }}
          onChange={onImgChange}
          style={{ display: 'none' }}
        />
        <IconButton
          name="upload-slide"
          icon={<FaUpload />}
          tooltip="Upload custom slide"
          title="Upload custom slide"
          onClick={() => inputRef.current.click()}
          variant="secondary"
          style={{ float: 'right' }}
        />

        {!isDefault && (
          <IconButton
            name="revert-slide"
            icon={<FaUndo />}
            tooltip={revertTitle}
            title={revertTitle}
            onClick={onRevertClick}
            variant="secondary"
            style={{ float: 'right', marginRight: '0.25em' }}
          />
        )}
      </div>
      <div
        style={{
          textAlign: 'center',
          position: 'absolute',
          bottom: '7.2%',
          width: '100%',
        }}
      >
        <img
          src={watermarkUrl}
          alt="Poly watermark"
          style={{
            width: '18.75%',
            visibility: isDefault || usePremiumPrompts ? 'hidden' : 'visible',
          }}
        />
      </div>
      <Card.Img
        data-testid={`${name}-img`}
        alt={`${name}-img`}
        variant="top"
        src={
          values[name] == null
            ? currentSlideUrl
            : URL.createObjectURL(values[name])
        }
        onLoad={onImageLoad}
        ref={imgRef}
        style={{ minWidth: '447px' }}
      />
    </>
  );
}

SlidePrompt.propTypes = {
  name: PropTypes.string,
  slideUrl: PropTypes.string,
  defaultSlideUrl: PropTypes.string,
  setPromptError: PropTypes.func,
  setShowPromptError: PropTypes.func,
};

export default SlidePrompt;
